import Quill from 'quill';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
    initEditor(element, targetInput) {
        const editor = new Quill(element, {
            theme: 'snow',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{image: true}]
                ],
            },
        });

        editor.on('text-change', () => {
            targetInput.value = editor.root.innerHTML;
        });

        return editor;
    },
}
